import React from 'react';
const TransformationSection = () => {
  return <div className="w-full bg-amber-50 text-gray-800 py-16 px-4" data-id="element-263">
      <div className="max-w-3xl mx-auto" data-id="element-264">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-265">
          Zeszyt pełen odkryć
        </h2>
        <p className="text-lg mb-6" data-id="element-266">
          Każdego dnia robiłam jedno małe ćwiczenie z e-booka. Pisałam w
          zeszycie rzeczy, które kiedyś lubiłam. Przypominałam sobie, o czym
          marzyłam. Kim byłam, zanim zostałam wszystkim dla wszystkich.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8" data-id="element-267">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-268">
            <p className="text-lg mb-2" data-id="element-269">Po tygodniu napisałam:</p>
            <p className="text-xl italic font-bold" data-id="element-270">"Lubiłam tańczyć."</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-271">
            <p className="text-lg mb-2" data-id="element-272">Po dwóch:</p>
            <p className="text-xl italic font-bold" data-id="element-273">
              "Marzyłam o własnym ogródku."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-274">
            <p className="text-lg mb-2" data-id="element-275">Po trzech:</p>
            <p className="text-xl italic font-bold" data-id="element-276">
              "Chciałam napisać książkę."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-277">
            <p className="text-lg mb-2" data-id="element-278">Po czterech:</p>
            <p className="text-xl italic font-bold" data-id="element-279">
              "Kochałam być sama na spacerach."
            </p>
          </div>
        </div>
        <p className="text-lg mb-6" data-id="element-280">
          To były małe rzeczy. Ale to były MOJE rzeczy. Po raz pierwszy od lat
          czułam, że istnieję jako ja, a nie tylko jako czyjaś mama czy córka.
        </p>
        <div className="w-full h-px bg-amber-200 my-10" data-id="element-281"></div>
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-282">
          Mama zauważyła pierwsza
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-amber-400" data-id="element-283">
          <p className="text-lg italic" data-id="element-284">
            "Kasiu, ty jakaś inna jesteś" – powiedziała mama po trzech
            tygodniach. "Taka... spokojna."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-285">
          Nie byłam spokojna. Byłam obecna. Po raz pierwszy od lat byłam w
          kontakcie ze sobą.
        </p>
        <p className="text-lg mb-6" data-id="element-286">
          Nadal opiekowałam się mamą. Nadal wspierałam dzieci. Ale robiłam to
          jako Kasia, a nie jako automat do załatwiania spraw.
        </p>
        <p className="text-lg mb-6 font-bold" data-id="element-287">
          Przestałam być niewidzialna dla samej siebie.
        </p>
        <h3 className="text-xl md:text-2xl font-bold mt-12 mb-6" data-id="element-288">
          Rozmowa z córką, która mnie zaskoczyła
        </h3>
        <div className="bg-white p-6 rounded-lg shadow-md my-8" data-id="element-289">
          <p className="text-lg mb-4" data-id="element-290">
            Miesiąc później córka przyszła do mnie wieczorem.
          </p>
          <p className="text-lg mb-4" data-id="element-291">
            "Mamo, ty się zmieniłaś" – powiedziała. "Nie wiem jak to nazwać,
            ale... jakbyś wróciła."
          </p>
          <p className="text-lg mb-4" data-id="element-292">"Wróciłam?" – zapytałam.</p>
          <p className="text-lg mb-4" data-id="element-293">
            "No wiesz. Przez lata byłaś, ale jakby cię nie było. A teraz jesteś.
            Naprawdę jesteś. I... przestałam się o ciebie martwić."
          </p>
          <p className="text-lg mb-4" data-id="element-294">
            To mnie zaskoczyło. "Martwiłaś się o mnie?"
          </p>
          <p className="text-lg" data-id="element-295">
            "Mamo, przez lata wyglądałaś jak duch. Robiłaś wszystko, ale jakbyś
            wcale nie żyła. Myślałam, że tak już zostanie na zawsze."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-296">
          Rozpłakałam się. Bo miała rację. Wróciłam. Do siebie.
        </p>
        <h3 className="text-xl md:text-2xl font-bold mt-12 mb-6" data-id="element-297">
          Syn, który zawsze wszystko widzi
        </h3>
        <div className="bg-white p-6 rounded-lg shadow-md my-8" data-id="element-298">
          <p className="text-lg mb-4" data-id="element-299">
            Gdy syn wracał na weekend przed swoim wyjazdem, pierwszą rzeczą,
            którą powiedział, było:
          </p>
          <p className="text-lg mb-4" data-id="element-300">
            "Mamo, co się stało? Wyglądasz... żywo."
          </p>
          <p className="text-lg mb-4" data-id="element-301">"Żywo?" – roześmiałam się.</p>
          <p className="text-lg" data-id="element-302">
            "Przez lata wyglądałaś jak zombie. Dobry zombie, który się o
            wszystkich troszczy, ale jednak zombie. A teraz... jesteś jak
            prawdziwa osoba."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-303">
          Te słowa utkwiły mi w pamięci. Prawdziwa osoba. To było to, na co
          czekałam przez lata, nie wiedząc, że tego szukam.
        </p>
      </div>
    </div>;
};
export default TransformationSection;